var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
class Util {
  constructor() {
    // e.g. private _modulePath: string =  ROUTES.dataSourceManagement.root.match.path
    __publicField(this, "_modulePath", `${ROUTES.scorecard.root.match.path}`);
    __publicField(this, "_modulePathname", `${ROUTES.scorecard.root.location.pathname}`);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        url: () => `${this.url}`
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const ScorecardRouteUtils = new Util();
export {
  ScorecardRouteUtils
};
//# sourceMappingURL=ScorecardRoute.utils.js.map
